<template>
  <div class="md-layout">
    <div
      v-if="this.loaded === false"
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
    >
      <md-card class="">
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon class="load-rotate">hourglass_empty</md-icon>
          </div>
          <h4 class="title">Widgets worden geladen...</h4>
        </md-card-header>
        <md-card-content> </md-card-content>
      </md-card>
    </div>

    <div
      v-if="this.noLoadedWidgetsAvailable()"
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
    >
      <md-card class="">
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>info</md-icon>
          </div>
          <h4 class="title">
            Helaas zijn er geen widgets gevonden om weer te geven.
          </h4>
        </md-card-header>
        <md-card-content> </md-card-content>
      </md-card>
    </div>

    <template v-for="(groupItem, groupItemIndex) in widgetData">
      <div
        :key="'group' + groupItemIndex"
        v-if="
          groupItem.length > 0 && exactlyOneLoadedWidgetAvailable() === false
        "
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
        <md-card class="">
          <md-card-header class="md-card-header-icon md-card-header-green">
            <div class="card-icon">
              <md-icon>{{ getWidgetGroupIcon(groupItemIndex) }}</md-icon>
            </div>
            <h4 class="title">
              {{ getWidgetGroupTitle(groupItemIndex) }}
            </h4>
          </md-card-header>
          <md-card-content> </md-card-content>
        </md-card>
      </div>
      <template v-for="(widget, widgetIndex) in groupItem">
        <template v-if="widget['widget_type']['data_type'] === 'date'">
          <date-widget
            :key="groupItemIndex + 'widget' + widgetIndex"
            :data="widget"
          ></date-widget>
        </template>
        <template v-if="widget['widget_type']['data_type'] === 'date+int'">
          <date-int-widget
            :key="groupItemIndex + 'widget' + widgetIndex"
            :data="widget"
          ></date-int-widget>
        </template>
        <template v-if="widget['widget_type']['data_type'] === 'string'">
          <string-widget
            :key="groupItemIndex + 'widget' + widgetIndex"
            :data="widget"
          ></string-widget>
        </template>
        <template v-if="widget['widget_type']['data_type'] === 'schedules'">
          <schedules-widget
            :key="groupItemIndex + 'widget' + widgetIndex"
            :data="widget"
          ></schedules-widget>
        </template>
        <template
          v-if="widget['widget_type']['data_type'] === 'unavailablePeriods'"
        >
          <start-stop-date-widget
            :key="groupItemIndex + 'widget' + widgetIndex"
            :data="widget"
          ></start-stop-date-widget>
        </template>
        <template v-if="widget['widget_type']['data_type'] === 'contactInfo'">
          <contact-widget
            :key="groupItemIndex + 'widget' + widgetIndex"
            :data="widget"
          ></contact-widget>
        </template>
        <template v-if="widget['widget_type']['data_type'] === 'shifts'">
          <shifts-widget
            :key="groupItemIndex + 'widget' + widgetIndex"
            :data="widget"
          ></shifts-widget>
        </template>
        <template
          v-if="widget['widget_type']['data_type'] === 'driverAvailability'"
        >
          <availability-widget
            :key="groupItemIndex + 'widget' + widgetIndex"
            :data="widget"
          ></availability-widget>
        </template>
        <template
          v-if="widget['widget_type']['data_type'] === 'changePassword'"
        >
          <change-password-widget
            :key="groupItemIndex + 'widget' + widgetIndex"
            :data="widget"
          ></change-password-widget>
        </template>
        <template v-if="widget['widget_type']['data_type'] === 'gpdr'">
          <gpdr-widget
            :key="groupItemIndex + 'widget' + widgetIndex"
            :data="widget"
          ></gpdr-widget>
        </template>
        <template v-if="widget['widget_type']['data_type'] === 'files'">
          <user-files-widget
            :key="groupItemIndex + 'widget' + widgetIndex"
            :data="widget"
          ></user-files-widget>
        </template>
      </template>
    </template>
  </div>
</template>
<script>
import DateWidget from "@/pages/Dashboard/Dashboard/DateWidget";
import DateIntWidget from "@/pages/Dashboard/Dashboard/DateIntWidget";
import StringWidget from "@/pages/Dashboard/Dashboard/StringWidget";

import AvailabilityWidget from "@/pages/Dashboard/Dashboard/Driver/AvailabilityWidget";
import ChangePasswordWidget from "@/pages/Dashboard/Dashboard/Driver/ChangePasswordWidget";
import ContactWidget from "@/pages/Dashboard/Dashboard/Driver/ContactWidget";
import GpdrWidget from "@/pages/Dashboard/Dashboard/Driver/GpdrWidget";
import SchedulesWidget from "@/pages/Dashboard/Dashboard/Driver/SchedulesWidget";
import ShiftsWidget from "@/pages/Dashboard/Dashboard/Driver/ShiftsWidget";
import StartStopDateWidget from "@/pages/Dashboard/Dashboard/Driver/StartStopDateWidget";
import UserFilesWidget from "@/pages/Dashboard/Dashboard/Driver/UserFilesWidget";

export default {
  components: {
    AvailabilityWidget: AvailabilityWidget,
    ChangePasswordWidget: ChangePasswordWidget,
    ContactWidget: ContactWidget,
    GpdrWidget: GpdrWidget,
    DateWidget: DateWidget,
    DateIntWidget: DateIntWidget,
    StartStopDateWidget: StartStopDateWidget,
    ShiftsWidget: ShiftsWidget,
    StringWidget: StringWidget,
    SchedulesWidget: SchedulesWidget,
    UserFilesWidget: UserFilesWidget
  },
  data() {
    return {
      widgetData: [],
      loaded: false
    };
  },
  methods: {
    loadWidgets() {
      this.$http.get(this.$apiBaseUrl + "dashboard").then(
        response => {
          this.widgetData = response.data.dashboard;
          this.loaded = true;
        },
        response => {
          if (response.status === 403) {
            this.generateDisabled = false;
            this.notifyVue(
              "U heeft geen rechten voor het bekijken van dashboards",
              "add_alert",
              "danger",
              0
            );
          }

          return [];
        }
      );
    },
    exactlyOneLoadedWidgetAvailable() {
      if (this.loaded === false) {
        return false;
      }

      let available = 0;

      for (let i in this.widgetData) {
        if (this.widgetData[i].length > 0) {
          available++;
        }
      }

      return available === 1;
    },
    noLoadedWidgetsAvailable() {
      if (this.loaded === false) {
        return false;
      }

      if (
        this.widgetData.length === 0 ||
        (this.widgetData.drivers_manager.length === 0 &&
          this.widgetData.driver.length === 0)
      ) {
        return true;
      }

      return false;
    },
    getWidgetGroupIcon(groupIndex) {
      if (groupIndex === "driver") {
        return "person";
      }

      return "people";
    },
    getWidgetGroupTitle(groupIndex) {
      if (groupIndex === "driver") {
        return "Chauffeur widgets";
      }

      return "Chauffeurs beheerders widgets";
    }
  },
  mounted() {
    this.loadWidgets();
  }
};
</script>
